import { CaseLinks, caseLinksManufacturer } from '@odo/shared-ui';
import { usePatientCard } from '../../../hooks/usePatientCard';
import { safeHref } from '../../../utils/safeHref';

interface PatientExternalLinksProps {
    patientId: string;
    // Only the manufacturer chip, and nothing at all while the case has no link.
    manufacturerOnly?: boolean;
}

// The case at the manufacturer and in Dental Monitoring, like the dashboard patient table's links.
export function PatientExternalLinks({
    patientId,
    manufacturerOnly = false
}: PatientExternalLinksProps) {
    const { data: card } = usePatientCard(patientId);
    const manufacturerLink = safeHref(card?.treatment?.manufacturerLink);
    if (manufacturerOnly && !manufacturerLink) return null;
    return (
        <CaseLinks
            manufacturer={caseLinksManufacturer(card?.treatment?.manufacturerSlug)}
            manufacturerLink={manufacturerLink}
            dmLink={safeHref(card?.monitoring?.dmLink)}
            manufacturerOnly={manufacturerOnly}
            className="flex-shrink-0"
        />
    );
}
